import { isSuccessLoading, post } from '../store';
import { changeToken } from '../../../../Api';
import { api } from '../../../../helpers';
export const getPost = async (postId) => {
    const response = await api(`/api/v1/publication/retrive/${postId}/`);
    if (!response.ok) {
        changeToken(response.status);
        return;
    }
    return await response.json();
};
export const init = async (postId) => {
    isSuccessLoading.set(false);
    post.set(await getPost(postId));
    isSuccessLoading.set(true);
};
export const sendPublicationViewLog = async (params) => {
    await api('/api/v1/logging/publication/read/', 'POST', params, true);
};
